import React from 'react';
import cx from 'classnames';
import styles from './styles.module.scss';

type StatsCardHeader = {
  companyName?: string;
  /** Colour variant for the company name. Defaults to 'green'. */
  companyVariant?: 'green' | 'neutral700' | 'neutral50';
  industry?: string;
  /** Pill colour variant for the industry label. Defaults to 'yellow'. */
  industryVariant?: 'yellow' | 'green';
};

type StatsCardProps = {
  header?: StatsCardHeader;
  children?: React.ReactNode;
  footer?: React.ReactNode;
  /** CSS color value for the card background. Defaults to $neutral50. */
  bgColor?: string;
  /** URL for a background image. When set, takes precedence over bgColor. */
  bgImage?: string;
  className?: string;
};

const StatsCard = ({header, children, footer, bgColor, bgImage, className}: StatsCardProps) => {
  let backgroundStyle: React.CSSProperties = {};
  if (bgImage) {
    backgroundStyle = {
      backgroundImage: `url(${bgImage})`,
      backgroundSize: 'cover',
      backgroundPosition: 'center'
    };
  } else if (bgColor) {
    backgroundStyle = {backgroundColor: bgColor};
  }

  const hasHeader = header?.companyName || header?.industry;

  return (
    <div className={cx(styles['stats-card'], className)} style={backgroundStyle}>
      {hasHeader && (
        <div className={styles['stats-card__header']}>
          {header?.companyName && (
            <span
              className={cx(
                styles['stats-card__company'],
                styles[`stats-card__company--${header.companyVariant ?? 'green'}`]
              )}>
              {header.companyName}
            </span>
          )}
          {header?.industry && (
            <span
              className={cx(
                styles['stats-card__industry'],
                styles[`stats-card__industry--${header.industryVariant ?? 'yellow'}`]
              )}>
              {header.industry}
            </span>
          )}
        </div>
      )}
      {children && <div className={styles['stats-card__content']}>{children}</div>}
      {footer && <div className={styles['stats-card__footer']}>{footer}</div>}
    </div>
  );
};

export default StatsCard;
